import React from 'react'
import './HeaderRight.css'

function HeaderRight() {
    return (
        <div className="App__HeaderRight">
            <ul className="MainMenu">
                {/* <li>Add New</li> */}
                <li>Join</li>
            </ul>
        </div>
    )
}

export default HeaderRight
